import { isAfter, isWithinInterval } from "./_date-fns";
import type { Time } from "./time";

/**
 * TODO STAC-22096 replace by ~/tools/date-time/Interval
 */

/**
 * @deprecated use ~/tools/date-time/Interval instead
 */
export type OpenInterval = [Time, Time | undefined];

/**
 * @deprecated use ~/tools/date-time/Interval instead
 */
export function isWithinOpenInterval(time: Time, [start, end]: OpenInterval): boolean {
	if (end == null) {
		return isAfter(time, start);
	}

	return isWithinInterval(time, { start, end });
}
